import { render, staticRenderFns } from "./BidButton.vue?vue&type=template&id=36b5e864&"
import script from "./BidButton.vue?vue&type=script&lang=js&"
export * from "./BidButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports